import React, { Component } from 'react';
import {array, bool, func, object, string} from 'prop-types';
import { contains } from 'ramda';

// Redux
import { connect } from 'react-redux';
import { execApiWithParam } from '../../../../actions/api/apiActions';
import {
  getLatestRecordRequest,
  getLastFiveRecords,
  recordSearch,
  saveUserPreferences,

} from '../../../../actions/health/healthActions.js';
import * as HealthTypes from '../../../../actions/health/types';
import { closeAlertDialog, openErrorDialog, openSuccessDialog } from '../../../../actions/dialog/dialogActions';
import { setHeaderTitle, showBackButton, hideBackButton } from '../../../../actions/header/headerActions';
import { setMetadata } from '../../../../actions/metadata/metadataActions';

// APIs
import HealthApi from '../../../../apis/health';

// Main Layout Components
import CareRecordViewer from 'updox-care-record-viewer';
import ContentPanel from '../../../ContentPanel';
import GetLatestRecord from '../GetLatestRecord';
import HealthRecordFilter from '../HealthRecordFilter';
import HealthRecordListContainer from '../HealthRecordListContainer';
import HealthRecordTransmitForm from '../HealthRecordTransmitForm';
import Layout from '../../../Layout/Layout';
import SecondaryHeaderBar from '../../../SecondaryHeaderBar/SecondaryHeaderBar';
import SlidingPanel from '../../../SlidingPanel';
import FixedSecondaryHeaderBar from "../../../FixedSecondaryHeaderBar/FixedSecondaryHeaderBar"
import BaseBackButton from "./../../../BaseBackButton/BaseBackButton";

import s from './HealthLandingPage.css';
import cx from 'classnames';

export class HealthLandingPage extends Component {
  static propTypes = {
    authenticatedPreferences: object,
    closeAlertDialog: func,
    getLastFiveRecords: func,
    getLatestRecord: func,
    header: object,
    hideHeaderBackButton: func,
    loadingState: object,
    openErrorDialog: func,
    openSuccessDialog: func,
    recordHeaders: array,
    recordSearch: func,
    saveUserPreferences: func,
    setHeaderTitle: func,
    setMetadata: func,
    showHeaderBackButton: func,
    expandedHealthRecordListContainer: bool,
    parentCallback: func,
    hasParentSecondaryMenu: bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      expandedTransmitForm: false,
      expandedViewRecord: false,
      showTransmitForm: false,
      careRecord: null,
      selectedHealthRecordListItem: {
        recordId: null,
        isLoading: false,
      },
      pagesStack:[], // When the stack is empty, we are on the home page. There are no sliding panels visible
    };

    // Practice level setting(s)
    this.latestRecordRequestsEnabled = this.props.authenticatedPreferences.latestRecordRequestsEnabled;
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.header.backButton && (this.state.expandedTransmitForm || this.state.expandedViewRecord || this.state.showTransmitForm)) {
      this.goBack();
    }
  }

  componentWillMount() {
    this.props.setMetadata({
      activeMenuItemKey: 'health',
      pageTitle: 'My Records',
      pageDescription: 'View your health documents',
    });
    this.props.setHeaderTitle('Health');
  };

  componentDidMount() {
    this.handleGetLastFiveRecords();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const pagesStackSize = this.state.pagesStack.length;
    let copyOfPagesStack = [...this.state.pagesStack];

    // if state has changed
    if(this.state.expandedTransmitForm !==prevState.expandedTransmitForm || this.state.expandedViewRecord !==prevState.expandedViewRecord || this.state.showTransmitForm !== prevState.showTransmitForm) {
      // One of the SlidingPanel components are visible, so add an item to the stack
      if(this.state.expandedTransmitForm || this.state.expandedViewRecord || this.state.showTransmitForm) {
        this.setState({
          pagesStack: [...this.state.pagesStack, pagesStackSize+1],
        })
      } else {
        copyOfPagesStack.pop(); // remove last page added
        this.setState({
          pagesStack: copyOfPagesStack,
        })
      }
    }
  }

  // Closes any of the open sliding panes. Reset state.
  goBack = () => {
    if (this.props.header.backButton) {
      this.props.hideHeaderBackButton();
    }

    this.setState({
      careRecord: null,
      expandedTransmitForm: false,
      expandedViewRecord: false,
      showTransmitForm: false,
    });

    // if stack is empty, there are no SlidingPanel components visible
    // we are on the Home section of Health Landing Page
    if(this.state.pagesStack.length ===0)
      this.props.parentCallback(true);
  };

  openTransmitPane = (transmitData) => {
    this.setState({
      showTransmitForm: true,
      expandedTransmitForm: true,
      transmitData
    });
    this.props.showHeaderBackButton();
  };

  openRecordPane = () => {
    this.setState({
      expandedViewRecord: !this.state.expandedViewRecord,
    });
    this.props.showHeaderBackButton();
  };

  // Toggles show/hide of Transmit Record form
  handleTransmitForm = (transmitData) => {
    // if the form is already open, don't toggle state,
    // just update the props passed
    if (this.state.showTransmitForm) {
      this.setState({
        transmitData,
      });

      return;
    }
    this.openTransmitPane(transmitData);
  };

  handleGetLastFiveRecords = () => this.props.getLastFiveRecords();

  handleRecordSearch = (startDate, endDate) => {

    if (startDate > endDate) {
      this.props.openErrorDialog({
        content: 'Start date must be before the end date.',
        okCallback: this.props.closeAlertDialog,
      });
      return;
    }

    this.props.recordSearch({ startDate, endDate });
  };

  // HealthRecordActions passes the ID of the Record
  handleViewRecord = (recordId) => {

    // SSPI-117: We do not invoke a Redux hooked loadingState (i.e. HealthTypes.VIEW_CARE_RECORD), just use a boolean.
    this.setState({
      selectedHealthRecordListItem: {
        recordId: recordId,
        isLoading: true,
      },
    });

    // POR-609: We invoke viewing a record in this manner to avoid state collisions where if a careRecord is returned in
    // a reducer and bound as props to this component, we would never receive updated record
    // sectionPreferences from the saveUserPreferences call.
    this.props.execApiWithParam({
      type: HealthTypes.VIEW_CARE_RECORD,
      api: HealthApi.viewRecord,
      param: recordId,
      successCallback: response => {
        this.setState({
          careRecord: response.data,
          selectedHealthRecordListItem: {
            recordId: null,
            isLoading: false,
          },
        });

        this.openRecordPane();
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: () => {
        this.setState({
          careRecord: null,
          selectedHealthRecordListItem: {
            recordId: null,
            isLoading: false,
          },
        });
      },
      useErrorDialog: true,
    });

  };

  // Pass the preferences Array set in the CareRecordViewer up to here where the call is made.
  handleSaveUserPreferences = sectionPreferences => {
    const prefs = { sectionPreferences };

    this.props.saveUserPreferences(prefs);
  };

  isLoadingRecords = loadingState => contains(HealthTypes.RECORD_SEARCH, loadingState.requests);

  isLoadingLatestRecord = loadingState => contains(HealthTypes.GET_LATEST_RECORD, loadingState.requests);

  render = () => {

    const { loadingState } = this.props;
    const transmitFormIsVisible = this.state.showTransmitForm;

    const isLoadingRecords = this.isLoadingRecords(loadingState);
    const isLoadingLatestRecord = this.isLoadingLatestRecord(loadingState);

    const renderRecordsUtility = () => {
      if (this.latestRecordRequestsEnabled) {
        return (
          <SecondaryHeaderBar className={s.secondaryHeader}>
            {this.latestRecordRequestsEnabled &&
            <GetLatestRecord
              loadingState={isLoadingLatestRecord}
              getLatestRecord={this.props.getLatestRecord}
            />
            }
            <HealthRecordFilter
              loadingRecordSearch={isLoadingRecords}
              recordSearch={this.handleRecordSearch}
              closeAlertDialog={this.props.closeAlertDialog}
              openErrorDialog={this.props.openErrorDialog}
            />
          </SecondaryHeaderBar>
        );
      }
      return (
        <SecondaryHeaderBar className={cx(s.secondaryHeader, s.secondaryHeaderFlexEnd)}>
          <HealthRecordFilter
            loadingRecordSearch={isLoadingRecords}
            recordSearch={this.handleRecordSearch}
            closeAlertDialog={this.props.closeAlertDialog}
            openErrorDialog={this.props.openErrorDialog}
          />
        </SecondaryHeaderBar>
      );
    };
    return (
      <Layout>
        <ContentPanel className={s.contentPanel}>
          {
            this.props.hasParentSecondaryMenu &&
            <FixedSecondaryHeaderBar className={cx(s.HealthLandingPageBackButtonContainer)}>
              <BaseBackButton onClick={this.goBack} buttonLabel={"Health"} />
            </FixedSecondaryHeaderBar>
          }
          {renderRecordsUtility()}
          <HealthRecordListContainer
              loadingAllRecords={isLoadingRecords}
              healthRecordHeaders={this.props.recordHeaders}
              handleTransmitForm={this.handleTransmitForm}
              selectedHealthRecordListItem={this.state.selectedHealthRecordListItem}
              handleViewRecord={this.handleViewRecord}
          />
        </ContentPanel>

        <ContentPanel className={s.slidingPanelOverride}>
          <SlidingPanel isCollapsed={this.state.expandedTransmitForm}>
            {transmitFormIsVisible &&
                <HealthRecordTransmitForm
                    handleViewTransmitForm={this.goBack}
                    transmitData={this.state.transmitData}
                    closeAlertDialog={this.props.closeAlertDialog}
                    openErrorDialog={this.props.openErrorDialog}
                    openSuccessDialog={this.props.openSuccessDialog}
                />
            }
          </SlidingPanel>
          {this.state.careRecord &&
              <SlidingPanel isCollapsed={this.state.expandedViewRecord}>
                <div className={s.careRecordWrapper}>
                  <CareRecordViewer
                      careRecordJson={this.state.careRecord}
                      saveUserPreferencesCB={this.handleSaveUserPreferences}
                  />
                </div>
              </SlidingPanel>
          }
        </ContentPanel>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  authenticatedPreferences: state.authenticatedPreferences,
  header: state.header,
  loadingState: state.loadingState,
  recordHeaders: state.health.recordHeaders,
});

const mapDispatchToProps = dispatch => ({
  execApiWithParam: apiConfig => dispatch(execApiWithParam(apiConfig)),
  getLatestRecord: () => dispatch(getLatestRecordRequest()),
  getLastFiveRecords: () => dispatch(getLastFiveRecords()),
  recordSearch: data => dispatch(recordSearch(data)),
  saveUserPreferences: preferences => dispatch(saveUserPreferences(preferences)),
  setHeaderTitle: title => dispatch(setHeaderTitle(title)),
  showHeaderBackButton: () => {
    dispatch(showBackButton())
  },
  hideHeaderBackButton: () => {
    dispatch(hideBackButton())
  },
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  openErrorDialog: (dialog) => dispatch(openErrorDialog(dialog)),
  openSuccessDialog: (dialog) => dispatch(openSuccessDialog(dialog)),
  setMetadata: metadata => dispatch(setMetadata(metadata)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HealthLandingPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthLandingPage/HealthLandingPage.js